import { render, staticRenderFns } from "./productIdUpload.vue?vue&type=template&id=33d90f44&scoped=true&"
import script from "./productIdUpload.vue?vue&type=script&lang=js&"
export * from "./productIdUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d90f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d90f44')) {
      api.createRecord('33d90f44', component.options)
    } else {
      api.reload('33d90f44', component.options)
    }
    module.hot.accept("./productIdUpload.vue?vue&type=template&id=33d90f44&scoped=true&", function () {
      api.rerender('33d90f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/productIdUpload.vue"
export default component.exports